import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { waitForSelector } from 'common/utils/waitForSelector';
import { selectIsFullyDisconnected } from 'features/caller-session/store';

export const waitForCallerSessionDisconnect = createAsyncThunk(
  'call/waitForCallerSessionDisconnect',
  async (_, { getState }) => {
    await waitForSelector(
      () => getState() as RootState,
      selectIsFullyDisconnected,
      {
        timeoutMs: 5000,
        intervalMs: 100,
        predicate: (v) => v === true,
      }
    );
  }
);
